import axios from 'axios';

const tenantApi = axios.create({
    baseURL: process.env.REACT_APP_TENANT_API_URL
});

export default tenantApi;